package com.macrofocus.nastac.ui

@Suppress("EnumEntryName")
enum class PaletteType {
    light,
    dark
}